import React, { createContext } from 'react'
import UseDirectory from '../hooks/UseDirectory';

// Creates a context to be used for the directory
const DirectoryContext = createContext();

function DirectoryProvider({ children }) {
    const {
        stateOptions,
        isStatesLoaded,
        countryOptions,
        isCountriesLoaded,
        categoryOptions,
        isCategoriesLoaded,
        subCategoryOptions,
        isSubCategoriesLoaded,
        listingPlans,
        isListingPlansLoaded,
        contactTypeOptions,
        isContactOptionsLoaded,
        inputSearchText,
        setInputSearchText,
        inputLocation,
        setInputLocation,
        inputCategory,
        setInputCategory,
        inputSubCategory,
        setInputSubCategory,
        inputListingPlan,
        setInputListingPlan
    } = UseDirectory();

    return (
        <DirectoryContext.Provider
            value={{
                stateOptions, isStatesLoaded,
                countryOptions, isCountriesLoaded,
                categoryOptions, isCategoriesLoaded,
                subCategoryOptions, isSubCategoriesLoaded,
                listingPlans, isListingPlansLoaded,
                contactTypeOptions, isContactOptionsLoaded,
                inputSearchText,
                setInputSearchText,
                inputLocation,
                setInputLocation,
                inputCategory,
                setInputCategory,
                inputSubCategory,
                setInputSubCategory,
                inputListingPlan,
                setInputListingPlan
            }}>
            {children}
        </DirectoryContext.Provider>
    )
}

export { DirectoryContext, DirectoryProvider }

